<template>
    <v-card-text
        component="VoicesList"
        :style="{ background: `${getColorById(getSelectedCharacter.farba)}!important` }"
    >
        <draggable
            :group="{ name: 'people', pull: 'clone', put: false }"
            :list="list"
            :sort="false"
            :filter="'.disabled'"
            :move="checkMove"
            :disabled="projectWasClosed"
        >
            <voices-list-item v-for="actor in list" :actor="actor" :key="actor.id" />
        </draggable>
        <div class="spacer"></div>
    </v-card-text>
</template>

<script>
import { mapGetters } from 'vuex';
import draggable from 'vuedraggable';
import VoicesListItem from '@/components/Project/Voices/VoicesListItem';

export default {
    name: 'VoicesList',

    components: { VoicesListItem, draggable },

    props: {
        list: {
            type: Array,
            require: true,
        },
    },

    methods: {
        checkMove(evt) {
            // odrb na blikanie ghostu v cieli dropovania

            setTimeout(() => {
                evt.dragged.classList.add('show');
            }, 100);
        },
    },

    computed: {
        ...mapGetters(['getSelectedCharacter', 'getColorById', 'projectWasClosed']),
    },
};
</script>

<style lang="less">
@import '~@variables';

[component='VoicesList'] {
    display: flex;
    flex-direction: column;
    position: relative;
    padding: 0;
    height: 0;
    flex-grow: 1;
    overflow-y: auto;
    flex-basis: 0;

    .spacer {
        height: 0;
        flex-grow: 1;
        width: 100%;
        background-color: fade(white, 20%);
    }

    .ghost {
        opacity: 0.5;
        background-color: white;
        display: none;
        border: none;
        min-height: 0;
        height: 0;

        &.show {
            min-height: 40px;
            height: 40px;
        }
    }
}
</style>
